import {EntityData, field, identifier} from "../resource/entity/entity.data";

export class NotificationData extends EntityData<NotificationData> {
    @identifier identifier: string;
    @field userId: string;
    @field username: string;
    @field messageKey: string;
    @field messageParams: string;
    @field actionLabelKey: string;
    @field type: string;
    @field data: string;
    @field viewed: boolean;
}
